import React, { useEffect, useState, useRef } from 'react';
// import { RecruiterComponent } from './recruiter';
import { RecruitmentComponent } from './recruitment';
import { getJobsData, getPanelMemberJobs, getHiringTeamLogin, getInterviewRound, getDropdown } from '../service/RecruiterApi';
import { Link, useNavigate } from 'react-router-dom';
import BreadCrumbs from './BreadCrumbs/BreadCrumbs';
import { encryptStorage } from '../constant';
import { generateBulkOfferLetter } from '../service/RecruiterApi';
import { read, utils, path } from 'xlsx';
import { getS3 } from '../utils/Download.js';

// import Loader from '../../StaticComponent/Loader';
export function JobsLanding() {
    let breadCrumbsData = [
        { title: 'Dashboard', path: '/overview', isActive: true },
        { title: 'Jobs', path: '/Recruitment', isActive: false },
    ];

    const defaultFilterValues = {
        status: '',
        employment_type: '',
        department: '',
        fromDate: '',
        toDate: '',
    };
    const navigate = useNavigate();

    const role = encryptStorage.getItem('role');
    const recruitRole = encryptStorage.getItem('recruitRole');
    const employeeId = encryptStorage.getItem('employeeId');
    let [hideCandidatePage, setHideCandidatePage] = useState(true);
    const [jobData, setJobData] = useState([]);
    const [jobCandidateCount, setjobCandidateCount] = useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [filterData, setFilterData] = React.useState(defaultFilterValues);
    const [departments, setDepartments] = React.useState([]);
    const [experience, setExperience] = React.useState();
    const [bulkUserArr, setBulkUserArr] = useState([]);

    const [validationMessage, setValidationMessage] = useState(' ');

    const [errorPopup, setErrorPopup] = useState(false);

    const [loader, setLoader] = useState(true);

    const [errorNumber, setErrorNumber] = useState('');

    const [fileName, setFileName] = useState('');

    const [hideToast, setHideToast] = useState(true);

    const [toastBodyMessage, setToastBodyMessage] = useState('');

    const [toastHeaderMessage, setToastHeaderMessage] = useState('');

    const [bulkOffer, setBulkOffer] = useState(true);

    const attachment = useRef(null);

    useEffect(() => {
        if (encryptStorage.getItem('groupid') == 1 || encryptStorage.getItem('recruitRole') == 'Panel Member') {
            hiringteam();
            loadJobsData();
        } else {
            navigate('/', { state: { hideNav: false } });
        }
    }, []);
    useEffect(() => {
        setTimeout(() => {
            setHideToast(true);
        }, 2500);
    }, [hideToast]);


    //Function to download the template for sending bulk offer
    // const downloadTemplate = async () => {
    //     try {
    //         let val=getS3('https://ava-hive-np-img-s3.s3.us-east-2.amazonaws.com/BulkOfferLetterTemplate.xlsx');
    //         window.open(val);
    //     } catch (e) {
    //         throw e;
    //     }
    // };

    let hiringteam = async () => {
        let response = await getHiringTeamLogin({ emp_id: employeeId });
        let response1 = await getDropdown();
        setDepartments(response1.data.data[0]);
    };
    let loadJobsData = async () => {
        try {
            let resp;
            if (recruitRole == 'Panel Member' && role !== 'Hr Manager') {
                setIsLoading(false);
                resp = await getPanelMemberJobs({ empId: employeeId });
                setIsLoading(true);
            } else {
                setIsLoading(false);
                resp = await getJobsData();
                setIsLoading(true);
            }

            setJobData(resp.data.data[0]);
            setExperience(resp.data.data[0].experience);
            setjobCandidateCount(resp.data.data[1]);
        } catch (e) { }
    };
    let bindJobsCard = () => {
        try {
            if (jobData?.length == 0) {
                return (
                    <div class="row justify-content-center no-records-top">
                        <img src="/Images/no-records-found.svg" alt="nodatafound" style={{ width: '100px' }} />
                        <h2 class="semibold-text font-20 form-label text-center mt-5 jobdetails-label-color">No Jobs Found</h2>
                    </div>
                );
            } else {
                return jobData.map((value, index) => {
                    return (
                        <div key={index} hidden={value.is_delete == true ? true : false} className="job-cus-col-20 mb-4">
                            <div className="card h-100 border-0 jobs-card shadow-sm">
                                <div className="card-body text-center rounded-3">
                                    <h1 className="font-12 job-card-labelcolor-1">{value?.department}</h1>
                                    <h1 className="font-16 bold-text mb-3">{value.job_title}</h1>
                                    <div className="jobposting-border d-inline-block justify-content-center">
                                        <h1 className="font-20 job-count-label-color semibold-text">
                                            {jobCandidateCount[index].id == value.id ? jobCandidateCount[index].count[0].count : 0}
                                        </h1>
                                        <h1></h1>
                                        <h1 className="font-12 semibold-text job-candidate-label-color">Candidate</h1>
                                    </div>
                                    <div className="mt-3 justify-content-center">
                                        <label className="regular-text font-12 job-gps-label-color pe-1">
                                            <span>
                                                <img src="/Images/GPRS Location.svg" className="pe-1" />
                                            </span>
                                            {value.location}
                                        </label>
                                        <label className="job-left-border ps-2 regular-text font-12 job-gps-label-color">
                                            {value.employment_type}
                                        </label>
                                    </div>
                                </div>
                                <div className="card-footer border-0 job-custom-footer d-flex justify-content-between pt-3">
                                    <label className="job-published-label semibold-text font-12">
                                        {value.is_closed == true
                                            ? 'Closed'
                                            : value.is_hold == true
                                                ? 'On Hold'
                                                : value.draft == true
                                                    ? 'Drafted'
                                                    : value.is_published == false
                                                        ? 'Drafted'
                                                        : 'Published'}
                                    </label>
                                    <a
                                        href={`/Recruitment/Jobs?id=${value.id}`}
                                        className="text-decoration-none semibold-text job-details-clr font-12"
                                    >
                                        Details
                                        <span>
                                            <img src="/Images/rightarrow.svg" className="ps-1" />
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    );
                });
            }
        } catch (e) { }
    };

    const filterValueChange = (e) => {
        setFilterData((filterData) => ({ ...filterData, [e.target.id]: e.target.value }));
    };

    const clearFilter = () => {
        setFilterData(defaultFilterValues);
        loadJobsData();
    };

    const applyFilter = async () => {

        const resp = await getJobsData(filterData);

        setJobData(resp.data.data[0]);
        setExperience(resp.data.data[0].experienced);
        setjobCandidateCount(resp.data.data[1]);
    };


    let readFile = (e) => {
        try {
            if (e) {
                setValidationMessage('');

                const typeArr = ['vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

                let type = typeArr.includes(e.target.files[0].type.split('/')[1]);

                if (type) {
                    setValidationMessage('');

                    const validationHeading = [
                        'candidate_id',

                        'effective_date',

                        'annual_ctc',

                        'offer_valid_till',

                        'reporting_manager',

                        'hr_manager',
                    ];

                    let files = e.target.files;

                    let f = files[0];

                    let userArr = [];

                    let reader = new FileReader();

                    reader.onload = (e) => {
                        const wb = read(e.target.result);

                        const sheets = wb.SheetNames;

                        const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);

                        if (rows.length >= 1) {
                            setValidationMessage('');

                            let columnTitle = Object.keys(rows[0]);

                            if (JSON.stringify(validationHeading) === JSON.stringify(columnTitle)) {
                                setFileName(files[0].name);

                                rows.map((value) => {

                                    // let effective_salary =
                                    //     value?.effective_date?.split('/')[2] +
                                    //     '/' +
                                    //     value?.effective_date?.split('/')[1] +
                                    //     '/' +
                                    //     value.effective_date?.split('/')[0];

                                    // let reporting_date =
                                    //     value?.offer_valid_till?.split('/')[2] +
                                    //     '/' +
                                    //     value?.offer_valid_till?.split('/')[1] +
                                    //     '/' +
                                    //     value.offer_valid_till?.split('/')[0];
                                    let effective_salary = value?.effective_date;
                                    let reporting_date = value?.offer_valid_till;

                                    // Check if the dates are in YYYY-MM-DD format
                                    if (effective_salary && /^\d{4}-\d{2}-\d{2}$/.test(effective_salary)) {
                                        let [year, month, day] = effective_salary.split('-');
                                        effective_salary = `${year}/${month}/${day}`;
                                    }

                                    if (reporting_date && /^\d{4}-\d{2}-\d{2}$/.test(reporting_date)) {
                                        let [year, month, day] = reporting_date.split('-');
                                        reporting_date = `${year}/${month}/${day}`;
                                    }
                                    let experience1 = value.candidate_id.startsWith('F') ? 'Fresher' : 'Experience';
                                    let tempUserObj = {
                                        emp_id: employeeId,

                                        salaryDetails: {
                                            candidate_id: value.candidate_id,

                                            exp: value.candidate_id.startsWith('F') ? 'Fresher' : 'Experience',

                                            effective_date: effective_salary,

                                            annual_ctc: `${value.annual_ctc} LPA`,

                                            hr_signature_url: 1,

                                            currency_id: 1,
                                        },

                                        reportingDetails: {
                                            candidate_id: value.candidate_id,

                                            exp: value.candidate_id.startsWith('F') ? 'Fresher' : 'Experience',

                                            offer_valid: reporting_date,

                                            reporting_manager: value.reporting_manager,

                                            hr_manager: value.hr_manager,
                                        },
                                    };


                                    userArr.push(tempUserObj);

                                    setBulkUserArr(userArr);
                                });
                            } else {
                                setFileName('');

                                cancelUpload();

                                setValidationMessage('Please upload the file with valid data');
                            }
                        } else {
                            setFileName('');

                            cancelUpload();

                            setValidationMessage('Please upload the file with valid data');
                        }
                    };

                    reader.readAsArrayBuffer(f);

                } else {
                    setFileName('');

                    cancelUpload();

                    setValidationMessage('Please upload the file in .xlsx format');
                }
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    const cancelUpload = async () => {
        try {
            setFileName('');

            attachment.current.value = null;
        } catch (e) {
            throw e;
        }
    };

    const generateBulkOffer = async () => {
        const generateResult = await generateBulkOfferLetter(bulkUserArr);
    
        

        setLoader(true);
        if (generateResult?.data.data[0]?.length != 0) {
        

            setErrorNumber(generateResult?.data.data[0]?.length);

            setErrorPopup(true);
        } else {
            setHideToast(false);

            setToastHeaderMessage('Success!');

            setToastBodyMessage('Sent Succesfully');
        }
    };

    return (
        <>
            <div className="body-bg">
                <div className="container-fluid mt-5">
                    {/*Tab - Starts here */}
                    <div className="row justify-content-between">
                        <BreadCrumbs data={breadCrumbsData} />
                        <div className="col-md-12 d-flex border-bottom justify-content-between align-items-center">
                            <ul className="nav nav-pills ps-1" id="pills-tab" role="tablist">
                                <li className="nav-item me-4">
                                    <button
                                        className="nav-link rounded-0 active bold-text tab-style"
                                        id="job-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-home"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-home"
                                        aria-selected="true"
                                        onClick={() => {
                                            setHideCandidatePage(true);
                                        }}
                                    >
                                        Job
                                    </button>
                                </li>
                                <li className="nav-item me-4">
                                    <button
                                        hidden={recruitRole == 'Panel Member' && role !== 'Hr Manager' ? true : false}
                                        className="nav-link rounded-0 bold-text tab-style"
                                        id="candidates-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-profile"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-profile"
                                        aria-selected="false"
                                        onClick={() => {
                                            setHideCandidatePage(false);
                                        }}
                                    >
                                        Candidates
                                    </button>
                                </li>
                            </ul>
                            <div className="dropdown d-flex">
                                <div className="dropdown">
                                    {hideCandidatePage == true ? (
                                        <button
                                            className="advanced-filter-button me-3 medium-text"
                                            type="button"
                                            id="dropdownMenuButton1"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            hidden={recruitRole == 'Panel Member' && role !== 'Hr Manager' ? true : false}
                                        >
                                            <img src="/Images/filter-icon.svg" alt="Filter-icon" className="me-2" />
                                            Filter
                                        </button>
                                    ) : null}
                                    <div
                                        className="dropdown-menu px-3 advanced-filter-panel dropdown-btn-adjust"
                                        aria-labelledby="dropdownMenuButton1"
                                    >
                                        <div className="row">
                                            <div className="col-md-12 py-2 border-0 mb-1">
                                                <span className="font-16 semibold-text advanced-filter-title">Advanced Filter</span>
                                                <button
                                                    type="button"
                                                    className="btn-close float-end close-filter"
                                                    data-bs-dismiss="advanced-filter"
                                                    aria-label="Close"
                                                />
                                            </div>
                                            <div className="col-md-12 ">
                                                <div className="row mb-3">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label hive-form-label" htmlFor="Domain">
                                                            Status
                                                        </label>
                                                        <select
                                                            className="form-select hive-form-select"
                                                            aria-label="Default select example2"
                                                            id="status"
                                                            name="status"
                                                            value={filterData.status}
                                                            onChange={filterValueChange}
                                                        >
                                                            <option value={''}>Select</option>
                                                            <option value={'Published'}>Published</option>
                                                            <option value={'onhold'}>On Hold</option>
                                                            <option value={'draft'}>Drafted</option>
                                                            <option value={'Closed'}>Closed</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label hive-form-label" htmlFor="Domain">
                                                            Job Type
                                                        </label>
                                                        <select
                                                            className="form-select hive-form-select"
                                                            aria-label="Default select example2"
                                                            id="experience"
                                                            value={filterData.experience}
                                                            onChange={filterValueChange}
                                                        >
                                                            {/* <option value={''}>Select</option>
                                                            <option value={'Experienced'}>Experienced</option>
                                                            <option value={'Fresher'}>Fresher</option> */}
                                                            {/* {bindJobsTitle()} */}
                                                            
                                                            <option value={''}>Select</option>
                                                            <option value={'Full-Time'}>Full-Time</option>
                                                            <option value={'Part-Time'}>Part-Time</option> 
                                                            <option value={'Contract'}>Contract</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3 ">
                                                        <label className="form-label hive-form-label" htmlFor="Approval_status">
                                                            Department
                                                        </label>
                                                        <select
                                                            className="form-select hive-form-select"
                                                            aria-label="Default select example2"
                                                            id="department"
                                                            value={filterData.department}
                                                            onChange={filterValueChange}
                                                        >
                                                            <option value={''}>Select</option>
                                                            {departments.map((department) => {
                                                                return <option value={department.id}>{department.department}</option>;
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 pb-2 border-0 ">
                                                    <span className="font-14 semibold-text filter-title">Date Range</span>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label hive-form-label" htmlFor="fromrange">
                                                            From
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control hive-form-control"
                                                            id="fromDate"
                                                            value={filterData.fromDate}
                                                            onChange={filterValueChange}
                                                            max={filterData.toDate}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label hive-form-label" htmlFor="forange">
                                                            To
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control hive-form-control"
                                                            id="toDate"
                                                            min={filterData.fromDate}
                                                            value={filterData.toDate}
                                                            onChange={filterValueChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 my-3 d-flex justify-content-end">
                                                <button
                                                    className="btn hive-btn-secondary me-3"
                                                    onClick={() => {
                                                        clearFilter();
                                                    }}
                                                >
                                                    Clear
                                                </button>
                                                <button
                                                    className="btn hive-btn-primary"
                                                    onClick={() => {
                                                        applyFilter();
                                                    }}
                                                >
                                                    Apply
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button
                                    hidden={hideCandidatePage}
                                    className="btn generate-offer-lette-btn small-button me-2"
                                    onClick={() => {
                                        setBulkOffer(false);
                                    }}
                                >
                                    <img src="Images/Generate-offerletter.svg" className="me-2" />
                                    Generate Offer Letter
                                </button>
                                <Link
                                    hidden={recruitRole == 'Panel Member' && role !== 'Hr Manager' ? true : false}
                                    to={'/Recruitment/AddJobs'}
                                    className="btn hive-btn-primary small-button"
                                >
                                    <img src="/Images/hive-add-icon.svg" className="me-2" />
                                    Add Job Posting
                                </Link>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="tab-content" id="pills-tabContent">
                                {/* Hiring Process - Start here */}
                                <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="job-tab">
                                    {/*Content - Starts here */}
                                    <div className="row mt-3">{bindJobsCard()}</div>
                                    {/*Content - Ends here */}
                                </div>
                                <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="candidates-tab"></div>
                                {/* Job Boards - Ends here */}
                            </div>
                        </div>
                    </div>
                    {/*Tab - Ends here */}
                </div>
                <div hidden={hideCandidatePage}>
                    {/* <RecruiterComponent jobs={jobData} /> */}
                    <RecruitmentComponent jobs={jobData} />
                </div>
            </div>
            <div>
                <div className="position-fixed col-md-12 position-toast d-flex justify-content-center end-0 p-3" style={{ zIndex: 11 }}>
                    <div
                        id="liveToast"
                        className="toast side-toast show"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                        hidden={hideToast}
                    >
                        <div className="col-md-12 p-2 float-start">
                            <div className>
                                <div className="toast-header border-toast">
                                    <img className="tick px-2 float-start" src="/Images/green-tick.svg" alt="toast" />

                                    <div className="float-start px-3 pe-3">
                                        <div className="bold-text font-18 toast-font-black">{toastHeaderMessage}</div>

                                        <div className="body-toast semibold-text font-12 toast-font-grey ">{toastBodyMessage}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                hidden={bulkOffer}
                className="modal fade show"
                style={{ display: 'block', backgroundColor: "rgba(0,0,0,0.6)" }}
                id="MyPopup"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog feedback-popup modal-dialog-centered border-0 ">
                    <div className="modal-content">
                        <div className="modal-header border-0">
                            <h5 className="modal-title font-18 semibold-text feedback-head-clr" id="exampleModalLabel">
                                Generate Offer Letter
                            </h5>

                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => {
                                    cancelUpload();

                                    setBulkOffer(true);

                                    setValidationMessage(' ');
                                }}
                            />
                        </div>

                        <div className="modal-body pt-2 pb-1">
                            <div className="row mb-4">
                                <div className="col-md-12">
                                    <label className="medium-text w-100 mb-3">
                                        Use this template to send offer letters to multiple candidates.
                                    </label>

                                    <a
                                        href="#"
                                        className="anchor-text font-15 text-decoration-none"
                                        style={{cursor:"pointer"}} onClick={async () => {

                                            window.open(await getS3('https://ava-hive-prod-image-s3.s3.ap-south-1.amazonaws.com/BulkOfferLetterTemplate.xlsx'), "_blank");
                                        }} 
                                        // onClick={() => {
                                        //     downloadTemplate();
                                        // }}
                                    >
                                        <img src="Images/excel.svg" alt="text" /> Download Template
                                    </a>

                                    <span>
                                        <img
                                            src="Images/info-icon.svg"
                                            alt="info-icon"
                                            className="ms-2"
                                            title="Please download the template given and update the required data for the candidate you want to sent offer with effective_date in dd/mm/yyyy format and annual_ctc in LPA"
                                        />
                                    </span>
                                </div>

                                <div className="mt-4">
                                    <label className="medium-text w-100 mb-3">Import candidates Details</label>

                                    <label htmlFor="voterid-upload" className="custom-file-upload-styles">
                                        <img className="me-2" src="Images/top-up.svg" alt="Upload Icon" />
                                        Upload
                                    </label>

                                    <input
                                        id="voterid-upload"
                                        className="custom-file-upload-btn"
                                        type="file"
                                        ref={attachment}
                                        onChange={(e) => {
                                            readFile(e);
                                        }}
                                    />
                                </div>

                                {fileName !== '' ? (
                                    <div>
                                        {fileName}

                                        <span className="ms-2">
                                            {fileName === '' ? null : (
                                                <img
                                                    src="/Images/profile-certificate-cancel.svg"
                                                    alt=""
                                                    onClick={() => {
                                                        cancelUpload();

                                                        setValidationMessage(' ');
                                                    }}
                                                />
                                            )}
                                        </span>
                                    </div>
                                ) : null}

                                <div>
                                    <span className="required">{validationMessage}</span>
                                </div>

                                <div className="col-md-12 justify-content-end d-flex">
                                    <button
                                        className="btn hive-btn-secondary me-3"
                                        onClick={() => {
                                            setBulkOffer(true);

                                            cancelUpload();

                                            setValidationMessage(' ');
                                        }}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        disabled={validationMessage === '' && fileName != '' ? false : true}
                                        className="btn hive-btn-primary"
                                        onClick={(e) => {
                                            setBulkOffer(true);

                                            cancelUpload();

                                            setValidationMessage(' ');

                                            setLoader(false);

                                            generateBulkOffer();
                                        }}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {errorPopup ? (
                <div

                    className="modal fade show"
                    style={{ display: 'block', backgroundColor: "rgba(0,0,0,0.6)" }}


                >
                    <div className="modal-dialog feedback-popup modal-dialog-centered border-0 ">

                        <div className="modal-content border-none">
                            <div className="row">
                                <div className="col-md-12 float-start text-center p-5">
                                    <img className="mb-2 text-center align-items-center" src="images/alert.png" alt="alert" style={{ height: '60px', width: '60px' }} />

                                    <label className="w-100 bold-text font-14 text-center mb-3">Sorry</label>

                                    <label className="w-100 bold-text font-12 text-center mb-3">
                                        Encountered an issue in sending the offer letter to {errorNumber} candidates. Please check your email
                                        for the details regarding the candidates.
                                    </label>

                                    <div className="col-md-12 float-start text-center">
                                        <button
                                            type="button"
                                            onClick={() => setErrorPopup(false)}
                                            className="btn hive-btn-error "
                                            data-bs-dismiss="modal"
                                        >
                                            OK
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                ''
            )}

            <div hidden={loader}>
                <div className="overlay">
                    <div className="position-absolute top-50 start-50 translate-middle">
                        <div className="spinner-border Loader primary-color align-center " role="status">
                            <span className="visually-hidden"></span>
                        </div>

                        <p className="loading-text font-white">Loading..</p>
                    </div>
                </div>

                {/* <!-- need to be bottom of the structure --> */}

                <script src="JS/jquery.min.js"></script>

                <script src="JS/popper.js"></script>

                <script src="JS/bootstrap.min.js"></script>
            </div>


        </>
    );
}
